
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';


function Furniturework() {



  const cardData =
  {
    keyword: ' All Types of Furniture Work Services',
    heading: 'Anjali Enterprises: All Types of Furniture Work Services ',
    headingDescription: 'Anjali Enterprises specializes in creating custom, high-quality furniture solutions that are tailored to meet the unique needs of homes, offices, and commercial spaces. Whether you are looking for modern designs or classic wooden pieces, our team offers expert craftsmanship and personalized service to transform your interiors into functional and stylish spaces.',

    "topPlaces": [
        {
          "title": "Custom Furniture Work",
          "description": "We specialize in custom furniture work, providing personalized designs that align with your specific needs and preferences. Whether it's a bespoke table, chair, or storage unit, we bring your furniture ideas to life with precision and care."
        },
        {
          "title": "High-Quality Furniture Fabrication",
          "description": "At Anjali Enterprises, we prioritize quality in every piece of furniture we create. Using the best materials and modern techniques, we ensure each piece is durable, functional, and aesthetically pleasing, perfect for enhancing any space."
        },
        {
          "title": "Furniture Design and Installation",
          "description": "Our expert team offers complete furniture design and installation services. From conceptualization to the final setup, we ensure that each piece complements your space and meets your needs, creating a seamless and beautiful experience."
        },
        {
          "title": "Wooden Furniture Work in Pune",
          "description": "We specialize in high-quality wooden furniture work in Pune, offering a wide range of designs that bring warmth and elegance to any space. Whether it's for your home, office, or commercial space, our wooden furniture solutions are crafted to last."
        },
        {
          "title": "Modern Furniture Designs",
          "description": "Stay ahead of the trend with our modern furniture designs that combine style, comfort, and functionality. We provide contemporary furniture that not only elevates your space but also maximizes usability."
        },
        {
          "title": "Office Furniture Work",
          "description": "We understand the importance of functional and stylish office furniture. Our office furniture work includes custom desks, chairs, storage solutions, and more, all designed to improve productivity and create a comfortable workspace."
        },
        {
          "title": "Custom-Made Furniture",
          "description": "At Anjali Enterprises, we pride ourselves on our ability to create custom-made furniture that perfectly matches your vision. From size and design to functionality, we deliver furniture solutions that are uniquely tailored to your space."
        },
        {
          "title": "Industrial Furniture Services",
          "description": "Our industrial furniture services are designed for both aesthetics and durability. We create furniture pieces that are built to withstand the demands of industrial environments while maintaining a modern, stylish look."
        },
        {
          "title": "Home Furniture Work",
          "description": "Transform your living spaces with our home furniture work. Whether you need bedroom furniture, living room pieces, or storage solutions, our custom designs are made to fit your home perfectly and enhance its beauty."
        },
        {
          "title": "Premium Furniture Contractors",
          "description": "Anjali Enterprises is known for its premium furniture services, offering the best craftsmanship and materials in every project. We work closely with clients to ensure that every piece meets their exact specifications, making us the top choice for high-quality furniture in Pune."
        },
        {
          "title": "Furniture for Homes and Offices",
          "description": "Whether you're outfitting a home or an office, we provide premium furniture solutions designed to fit the specific needs of each space. From modern to traditional, our custom-made pieces elevate both residential and commercial environments."
        },
        {
          "title": "Anjali Enterprises Contact Number",
          "description": "Contact Anjali Enterprises at +91 8793220265 for reliable and high-quality furniture work. We specialize in all types of furniture services, including custom furniture design, fabrication, installation, and restoration, providing durable and stylish solutions for both residential and commercial spaces. Get in touch for expert craftsmanship and professional service. Serving Pune with top-notch furniture work tailored to your specific needs and preferences."
        }
      ],
      "tableData": [
        ["- Custom Furniture Work", "- High-Quality Furniture Fabrication"],
        ["- Furniture Design and Installation", "- Wooden Furniture Work in Pune"],
        ["- Modern Furniture Designs", "- Office Furniture Work"],
        ["- Custom-Made Furniture", "- Industrial Furniture Services"],
        ["- Home Furniture Work", "- Premium Furniture Contractors"],
        ["- Furniture for Homes and Offices", "- Anjali Enterprises Contact Number"]
      ],


   "whychoose": [
  {
    "WhyChooseheading": "Custom Furniture Solutions",
    "WhyChoosedescription": "At Anjali Enterprises, we specialize in designing and creating high-quality custom furniture tailored to meet your specific needs. Whether you're looking for office furniture, home furniture, or bespoke pieces for unique spaces, our team of experts is dedicated to crafting furniture that fits your vision perfectly. We collaborate with you from concept to completion to ensure that every piece aligns with your aesthetic preferences and functional requirements, making your space more personalized and comfortable."
  },
  {
    "WhyChooseheading": "Wide Range of Furniture Options",
    "WhyChoosedescription": "We offer an extensive selection of furniture for various needs, including residential, commercial, and industrial spaces. Whether you're outfitting a home with stylish furniture, designing a productive office setup, or furnishing a large commercial or industrial environment, we provide versatile solutions that suit every style, budget, and requirement. From contemporary to classic designs, our collection ensures that there is a perfect match for every space and need."
  },
  {
    "WhyChooseheading": "Durability and Quality Materials",
    "WhyChoosedescription": "Our furniture is crafted using only the finest materials, ensuring durability, longevity, and timeless appeal. We use premium wood, metal, and other top-grade materials to create furniture that not only meets functional requirements but also enhances the aesthetics of your space. With our high-quality materials, you can trust that every piece is designed to withstand daily use and continue to look great for years to come."
  },
  {
    "WhyChooseheading": "Skilled Craftsmanship",
    "WhyChoosedescription": "With years of experience in furniture design and fabrication, our skilled craftsmen deliver impeccable quality and attention to detail in every piece of furniture. Whether it's intricate woodwork or modern, minimalist designs, we take pride in delivering furniture that reflects exceptional craftsmanship. Every joint, finish, and detail is carefully considered, ensuring that the final product is of the highest standard and built to last."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "We believe in offering competitive and affordable pricing for all our furniture services, without compromising on quality. Our transparent pricing ensures that there are no hidden costs, and you know exactly what you’re paying for. Whether you're furnishing a small room or an entire office, we offer solutions that fit within your budget while providing great value for your investment. With us, you can be confident you're getting the best furniture at the right price."
  },
  {
    "WhyChooseheading": "End-to-End Furniture Services",
    "WhyChoosedescription": "From conceptual design and prototyping to manufacturing and installation, Anjali Enterprises offers end-to-end furniture services. Our dedicated team is involved in every step of the process, ensuring a seamless and efficient experience. We work closely with you to bring your vision to life, managing every detail along the way to ensure the final product exceeds your expectations. Our comprehensive service takes care of all aspects, so you don’t have to worry about a thing."
  },
  {
    "WhyChooseheading": "Customization and Personalization",
    "WhyChoosedescription": "At Anjali Enterprises, we understand that each client has unique preferences and needs. That's why we offer a high degree of customization, allowing you to choose from a variety of materials, colors, sizes, and finishes that suit your specific taste and functional requirements. Whether you're looking to match an existing decor or create something entirely new, we ensure your furniture is truly personalized, reflecting your style while meeting practical needs."
  },
  {
    "WhyChooseheading": "Timely Delivery and Installation",
    "WhyChoosedescription": "We understand the importance of meeting deadlines, and we prioritize timely delivery and installation for all our furniture projects. Our team works efficiently to ensure that every piece of furniture is delivered and installed within the agreed timeframe, ensuring a smooth and hassle-free experience. Whether it's for a residential home or a commercial office, we guarantee that your furniture will be ready and set up when you need it."
  },
  {
    "WhyChooseheading": "Sustainability and Eco-friendly Practices",
    "WhyChoosedescription": "At Anjali Enterprises, we are committed to sustainability and eco-friendly practices. We use environmentally friendly materials and processes wherever possible, ensuring our furniture is both stylish and sustainable. Our commitment to eco-consciousness extends to all aspects of our work, from sourcing sustainable wood to utilizing low-impact manufacturing methods. With us, you can furnish your space with beautiful pieces that also align with your values, promoting a greener future."
  }
]


  }

  const faqData = [
    {
      question: "What types of furniture do you offer?",
      answer: "We offer a wide variety of furniture including home furniture (living room, bedroom, dining room), office furniture (desks, chairs, conference tables), industrial furniture, and custom-built furniture solutions for specific requirements."
    },
    {
      question: "Can you provide custom furniture?",
      answer: "Yes, we specialize in creating custom furniture tailored to your specific needs. Whether you need unique office furniture, bespoke living room pieces, or any other customized solution, we can create furniture that fits your vision and space."
    },
    {
      question: "What materials do you use for your furniture?",
      answer: "We use a range of high-quality materials, including wood, metal, glass, and eco-friendly materials. We ensure that the materials chosen meet both aesthetic and durability requirements for each piece."
    },
    {
      question: "How long does it take to complete a custom furniture project?",
      answer: "The time required depends on the complexity and size of the project. Typically, custom furniture projects take anywhere from a few days to a few weeks. We provide an estimated timeline and keep you updated throughout the process."
    },
    {
      question: "Do you offer office furniture for businesses?",
      answer: "Yes, we offer a full range of office furniture, including desks, chairs, filing cabinets, conference tables, and ergonomic solutions. We can also create custom office furniture to fit your business’s specific needs."
    },
    {
      question: "How do I place an order for custom furniture?",
      answer: "You can place an order by contacting us directly. Our team will work with you to understand your requirements, design preferences, and budget. We will provide a detailed proposal and timeline for your approval before beginning the work."
    },
    {
      question: "Can you install the furniture once it is ready?",
      answer: "Yes, we provide professional installation services for all our furniture. Our team ensures that the furniture is set up correctly and efficiently, whether it's for your home or office."
    },
    {
      question: "What makes Anjali Enterprises’ furniture different from others?",
      answer: "At Anjali Enterprises, we prioritize quality, craftsmanship, and customer satisfaction. We offer custom solutions, use high-quality materials, and provide affordable pricing, ensuring that every piece of furniture we create is functional, durable, and stylish."
    },
    {
      question: "Do you offer repair services for furniture?",
      answer: "Yes, we offer furniture repair services. Whether your furniture needs minor fixes or extensive repairs, our team can restore its functionality and appearance."
    },
    {
      question: "Is your furniture eco-friendly?",
      answer: "Yes, we are committed to sustainability. We use eco-friendly materials wherever possible and employ environmentally responsible practices in our manufacturing processes."
    }
  ];
  
  const testimonials = [
    {
      name: "Mr. Rajesh Kumar",
      text: "I ordered custom furniture for my office from Anjali Enterprises, and I couldn't be happier with the results! The quality is top-notch, and the design perfectly matches my office’s aesthetic. The team was professional, and the installation was quick and efficient."
    },
    {
      name: "Ms. Priya Joshi",
      text: "Anjali Enterprises provided us with beautiful and durable home furniture. The customization options were fantastic, and we were able to create a unique design for every room. Highly recommend their services to anyone looking for custom furniture!"
    }
  ];
  



  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>{testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: " Anjali Enterprises Contact Information:",
    contactNumbers: [
      "+91 8793220265",

    ],
    email: "info@anjalienterprisesindia.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "All Types of Aluminium Glass Office Partition",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "All Types of Toughened Glass Work",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Door Partition",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "ACP Cladding Panel Installation",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Aluminium Glass Window",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Soundproof Glass Window",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Aluminium Mosquito Net",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bird Net Installation",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Invisible Grill Installation",
    },
    {
      place: "/images/keyword/10.jpg",
      text: " MS Fabrication Door",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "MS Fabrication Shade",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "MS Fabrication Grill",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "MS Fabrication Slide Door ",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "MS Fabrication Industrial Shade",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "All Types of Industrial Fabrication Work",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "All Types of Furniture Work",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "All Types of Industrial Work",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "All Types of Home Renovation Work",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "All Types of Painting Work",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Foil Ceiling Work",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Electrical Work",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Puff Panel Room ",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "PCC Work & Epoxy Flooring Work ",
    },
  ];


  const images = [
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },

  ];



  return (
    <div>



<Helmet>
  <title> Furniture Work Services in Pune</title>
  <meta name="description" content="Anjali Enterprises offers all types of furniture work in Pune, including custom furniture design and installation, modern furniture, wooden furniture, and office furniture solutions. Call +91 8793220265 for premium furniture services." />
  <meta name="keywords" content="Custom Furniture Work, High-Quality Furniture Fabrication, Furniture Design and Installation, Wooden Furniture Work Pune, Modern Furniture Designs, Office Furniture Work, Custom-Made Furniture, Industrial Furniture Services, Home Furniture Work, Premium Furniture Contractors, Furniture for Homes and Offices" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8793220265 | Anjali Enterprises | Furniture Work Services in Pune" />
  <meta property="og:description" content="Anjali Enterprises offers all types of furniture work in Pune, including custom furniture design and installation, modern furniture, wooden furniture, and office furniture solutions. Call +91 8793220265 for premium furniture services." />
  <meta property="og:image" content="https://anjalienterprisesindia.com/images/furniture-work-service.jpg" />
  <meta property="og:url" content="https://anjalienterprisesindia.com/furniture-work-services" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="Anjali Enterprises" />

  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "Anjali Enterprises",
        "description": "Anjali Enterprises offers all types of furniture work in Pune, including custom furniture design and installation, modern furniture, wooden furniture, and office furniture solutions. Call +91 8793220265 for premium furniture services.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411057",
          "addressCountry": "IN"
        },
        "telephone": "+91-8793220265",
        "email": "info@anjalienterprisesindia.com",
        "url": "https://anjalienterprisesindia.com/furniture-work-services",
        "logo": "https://anjalienterprisesindia.com/images/anjali-enterprises-logo.jpg",
        "image": "https://anjalienterprisesindia.com/images/furniture-work-service.jpg",
        "priceRange": "₹5000 - ₹50000",
        "offers": {
          "@type": "Offer",
          "url": "https://anjalienterprisesindia.com/furniture-work-services",
          "priceCurrency": "INR",
          "price": "5000",
          "priceValidUntil": "2025-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.9",
          "reviewCount": "50"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Neha S"
            },
            "datePublished": "2024-07-22",
            "reviewBody": "We commissioned custom furniture work for our office, and Anjali Enterprises delivered outstanding results. The design was modern and of excellent quality. Highly recommended!"
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Rajesh K"
            },
            "datePublished": "2024-10-05",
            "reviewBody": "The team at Anjali Enterprises provided premium furniture for our home. From design to installation, their attention to detail was remarkable. Very satisfied with the service!"
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Anjali Enterprises Service Area",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5195",
            "longitude": "73.8551"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://anjalienterprisesindia.com/furniture-work-services"
        },
        "keywords": "Custom Furniture Work, High-Quality Furniture Fabrication, Furniture Design and Installation, Wooden Furniture Work Pune, Modern Furniture Designs, Office Furniture Work, Custom-Made Furniture, Industrial Furniture Services, Home Furniture Work, Premium Furniture Contractors, Furniture for Homes and Offices"
      }
    `}
  </script>
</Helmet>


      {/* Banner */}
      <div className="inner-pages-bnr">
        <img src="images/service-banner.jpg" className="img-responsive" alt="Service-banner-image" />
        <div className="banner-caption">
          <h1 className='text-white'>{cardData.keyword}</h1>
        </div>
      </div>



      <section>
        <div className="" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/16.jpg' className='img-fluid' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#24ABE2', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}

              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {/* {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))} */}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <h3 className='Colo'>Why Choose Anjali Enterprises for {cardData.keyword}  </h3>

              <div id="why-choose-section"
                className='px-2'>


                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>

              <div>
                <h3 className='Colo'>FAQs{cardData.keyword} for Anjali Enterprises</h3>
                <Accordion data={faqData} />
              </div>
              <div className=''>


                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>

              <div className='py-5'>

                <div className="contact-box borderrr py-md-3">
                  <h2>{contactData.heading}</h2>
                  <p>For inquiries, quotes, or assistance with your aluminium glass office partition needs, please contact us:</p>
                  <div className="contact-details">
                    <p><strong className=''>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5 darkcolor">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className=''>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link darkcolor">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >

              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>

                );
              })}










              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '1px solid #24ABE2',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                  color: 'white'
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#24ABE2' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8793220265 " className="d-block  text-white">+91 8793220265 </a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#24ABE2' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@anjalienterprisesindia.com" className=" text-white d-block">
                          info@anjalienterprisesindia.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#24ABE2' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i>

                            Anjali Enterprises:<br />
                            Shop No 7 Vishal Deep Residency M  <br />
                            Perk Nagar Highway, Chandan Nagar<br />
                            Vadgaon Sheri,  (Near NA Bus Stop) Pune <br />
                            Maharashtra 411014
                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <Gallery images={images} ></Gallery>

              </div>

            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Furniturework;